<!-- <div class="green">
  <div class="modal-header modal-header-warn">
    <h4 class="modal-title">{{ title | translate }}</h4>
    <button
      type="button"
      class="btn btn-link btn-link-white btn-lg pull-right p-0"
      (click)="dismiss()"
    >
      <i class="far fa-times pe-2"></i>
    </button>
  </div>
  <div class="modal-body">
    <mat-card class="p-3">
      <div class="flex-row flex-row-h-center mb-2">
        {{ text | translate }}
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" (click)="dismiss()">
          {{ 'General.cancel' | translate }}
        </button>

        <button type="button" class="btn btn-themecolor" (click)="submit()">
          {{ 'General.confirm' | translate }}
        </button>
      </div>
    </mat-card>
  </div>
</div> -->

<div class="modal-header">
  <h4 class="modal-title" [ngClass]="variant != null ? 'text-' + variant : ''">
    {{ title | portalTranslate }}
  </h4>
  <button class="btn-close" (click)="trigger(false)" aria-label="Close" type="button"></button>
</div>
<div class="modal-body">
  @if (error != null) {
    <portal-error-alert [error]="error"></portal-error-alert>
  }

  @if (errors != null) {
    <portal-errors [dismissible]="false" [errors]="errors"></portal-errors>
  }

  <div [innerHTML]="text | portalTranslate"></div>
</div>
<div class="modal-footer">
  <button class="btn btn-link" (click)="trigger(false)" type="button">
    {{ cancelText | portalTranslate }}
  </button>

  <portal-save-button [portalAutofocus]="true" [state]="loading" [variant]="variant" (save)="trigger(true)">
    {{ okText | portalTranslate }}
  </portal-save-button>
</div>
